import { selectAudioFile, selectIntroMessagesList } from '@selectors/introMessages';
import {
  createIntroMessage,
  disableIntroMessage,
  getIntroMessagesRequestAction,
  setIntroMessageAudio,
} from '@actions/introMessages';
import { connect } from 'react-redux';
import { IntroMessages } from '@pages/AdminPage/IntroMessages.component';

const mapStateToProps = (state) => ({
  introMessagesList: selectIntroMessagesList(state),
  audioMessageFile: selectAudioFile(state),
  isFetching: state.introMessages.isFetching,
});

const mapDispatchToProps = {
  createIntroMessage,
  disableIntroMessage,
  setIntroMessageAudio,
  getMessages: getIntroMessagesRequestAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IntroMessages);



// WEBPACK FOOTER //
// ./components/pages/AdminPage/IntroMessages.container.js